import { Component, HostListener, OnInit } from '@angular/core';
import {CommonModule }  from '@angular/common'
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
// import {InitiatorHeadComponent} from '../initiator/initiatorhead.component'
import {HeaderComponent} from '../collabo/header.component';
import { LoginService } from '../../login-service';
import { ImageuploadService } from '../../Imageupload.service';
@Component({
    selector: 'myaccount-app',
    templateUrl: 'myaccount.component.html',
    providers:[HeaderComponent]
})

export class MyaccountComponent implements OnInit {
  displaylegaldocs:boolean=false;
  displaycertificates:boolean=false;
  displayportfolio:boolean=false;
  url:any;
    userData:any=[];
    documentsList:any;
    ProfilePic:any;
    skillsList:any;
    filteredskillsList:any=[];
    filtereddocList:any=[];
    workList:any;
    filteredworkList:any=[];
    educationList:any;
    filterededucationList:any=[];
    certificateList:any;
    filteredcertificateList:any=[];
    portfolioList:any;
    filteredportfolioList:any=[];
    userID:any;
    usertype:any;
    addnewwork: boolean=false;
    addnewcert:boolean=false;
    initiatordisplay: boolean=true;
    workIndustry:any;
    workExperience:any;
    workDescription:any;
  change: string;
  diff: string;
    rowID:any;
    type:string;
    certificateCopy:any;
    certificateTitle:any;
    certificateDesc:any;
    tempUsersList:any;
    collegeName:any;
    educationStartDate:any;
    educationEndDate:any;
    addnewed:boolean=false;
    UsersList:any;
    addnewport: boolean=false;
    portfolio: any;
    portfolioTitle: any;
    portfolioDesc: any;
    reference:any;
    capitalInvestment:any;
    experience:any;
    industry:any;
    city:any;
    district:any;
    country:any;
    legalName:any;
    documentType:any;
    legalDoc:any;
    editdoc:boolean=false;
    filteredSkillsnameList:any=[];
  skillsList2: any;
   filteredskillsList2:any=[];
   filteredskillsList3:any=[];
  imagefile: void;
  IsProfilePic:boolean=false;
  dragAreaClass:any;
  documetpath:any
  documentpath: any;
  filename: string;
  typeoffile: any;
  DocumentName: any;
  certificatename: any;
  portfolioname: any;
    constructor(private cheader:HeaderComponent,private loginService:LoginService,private router: Router,public imageservice: ImageuploadService) {
     
     }

    ngOnInit() {
        this.userID=localStorage.getItem('USERID');
        this.usertype=localStorage.getItem('userType');
        this.diff=localStorage.getItem('SIGNEDUPAS');
        this.change=localStorage.getItem('PROCESS')
      
        this.getLegaldocuments();
        this.getSkillsregion();
        this.getWorkexperience();
        this.getEducation();
        this.getCertification();
        this.getPortfolio();
        this.getSkills();
        this.GetUsers();

        if(this.change=='login')
        {
          if(this.usertype=="1")
        {
          this.initiatordisplay=false;
        }
        else{
          this.initiatordisplay=true;
        }
        }
        else if(this.change=='signup')
        {
          if(this.diff=="i")
        {
          this.initiatordisplay=false;
        }
        }
  
     }

     navigate()
     {
      
     }

     //drag
@HostListener("dragover", ["$event"]) onDragOver(event: any) {
  this.dragAreaClass = "droparea";
  event.preventDefault();
}
@HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
  this.dragAreaClass = "droparea";
  event.preventDefault();
}
@HostListener("dragend", ["$event"]) onDragEnd(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
}
@HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
}
@HostListener("drop", ["$event"]) onDrop(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
  event.stopPropagation();
  if (event.dataTransfer.files) {
    
    let files: FileList = event.dataTransfer.files;
    
    this.filename=files[0].name
    
     if(files[0].type=="application/pdf"||"application/doc")
     {
    this.imagefile = this.loginService.filechange2(files[0],files.length,this.userID,this.typeoffile);
    
    this.imageservice.ImageUplode1.subscribe(Img => this.documentpath = Img
      );
      
     }
     else if(files[0].type=="image/png"||"image/jpg"||"image/jpeg")
     {
      this.imagefile = this.loginService.filechange2(files[0],files.length,this.userID,this.typeoffile);
     
      this.imageservice.ImageUplode.subscribe((Img) => {this.documentpath = Img;
       
      });
     
     }
  }
}

     getSkillsregion(){
        this.loginService.GetRegionSkills().subscribe(data=>
            {
              data = JSON.parse(data['_body']);
              this.skillsList =JSON.parse(JSON.stringify(data));
             
              this.filteredskillsList=this.skillsList.filter(x=>x.userid.toString()===this.userID.toString());
             
              this.filteredskillsList[0].Skillid=JSON.parse(this.filteredskillsList[0].Skillid);
              
             
            });
     }
      /* Retrieve skills records from the database*/
    getSkills() {
      this.loginService.Getskills(1).subscribe(data => {
          data = JSON.parse(data['_body']);
          this.skillsList2 =JSON.parse(JSON.stringify(data));
         
          for(let i=0;i<this.filteredskillsList[0].Skillid.length;i++)
          {
            var sid=this.skillsList2.filter(x=>x.id.toString()===this.filteredskillsList[0].Skillid[i].toString())
           
            if(sid.length>0){
            this.filteredskillsList2.push(sid);
            }
          }
         
        for(var i=0;i<this.filteredskillsList2.length;i++){
          var sname=(this.filteredskillsList2[i][0]).skillname;
          this.filteredSkillsnameList.push(sname);
        }
        var AdditionalSkills=JSON.parse(this.filteredskillsList[0].AdditionalSkills);
        this.filteredSkillsnameList.push(AdditionalSkills)
       
        });
  }
     getLegaldocuments(){
        this.loginService.GetLegalDocuments().subscribe(data=>
            {  
              data = JSON.parse(data['_body']);
              this.documentsList =  JSON.parse(JSON.stringify(data));
             
              this.filtereddocList=this.documentsList.filter(x=>x.userid.toString()===this.userID.toString());
              
            });
       
     }
     getWorkexperience(){
        this.loginService.GetWorkExperience().subscribe(data=>
            { 
              data = JSON.parse(data['_body']);
              this.workList =data;
             
              this.filteredworkList=this.workList.filter(x=>x.userid.toString()===this.userID.toString());
          
            });
     }
     getEducation(){
        this.loginService.GetEducation().subscribe(data=>
            {
              data = JSON.parse(data['_body']);
              this.educationList =JSON.parse(JSON.stringify(data));
             
              this.filterededucationList=this.educationList.filter(x=>x.userid.toString()===this.userID.toString());
              
            });
     }
     getCertification(){
        this.loginService.GetCertification().subscribe(data=>
            {
              data = JSON.parse(data['_body']);
              this.certificateList =JSON.parse(JSON.stringify(data));
              
              this.filteredcertificateList=this.certificateList.filter(x=>x.userid.toString()===this.userID.toString());
              this.filteredcertificateList=JSON.parse(JSON.stringify(this.filteredcertificateList));
             
            });
     }
     getPortfolio(){
        this.loginService.GetPortfolio().subscribe(data=>
            {
              data = JSON.parse(data['_body']);
              this.portfolioList = JSON.parse(JSON.stringify(data));
              
              this.filteredportfolioList=this.portfolioList.filter(x=>x.userid.toString()===this.userID.toString());
             
            });
     }
     closefile()
     {
      this.displaylegaldocs=false;
      this.displaycertificates=false;
      this.displayportfolio=false;
     }

     editLegaldocs(){
       this.displaylegaldocs=true;
       this.typeoffile="legaldoc";
         this.editdoc=true;
        
         this.rowID=this.filtereddocList[0].RowID;
         this.documentType=this.filtereddocList[0].TypeOfProof;
         this.legalName=this.filtereddocList[0].LegalName;
         this.country=this.filtereddocList[0].Country;
         this.city=this.filtereddocList[0].City;
         this.district=this.filtereddocList[0].DistrictTown;
         this.industry=this.filtereddocList[0].Industry;
         this.experience=this.filtereddocList[0].Experience;
         this.capitalInvestment=this.filtereddocList[0].CapitalInvestment;
         this.reference=this.filtereddocList[0].Reference;
         

     }
     openclick(event:any)
     {
      event.preventDefault();
      let element:HTMLElement=document.getElementById('uploadpic') as HTMLElement;
      element.click();
     }
     saveLegaldocs(){
        const json={
            TypeOfProof:this.documentType,
            LegalName:this.legalName,
            Country:this.country,
            City:this.city,
            DistrictTown:this.district,
            Industry:this.industry,
            Experience:this.experience,
            CapitalInvestment:this.capitalInvestment,
            Reference:this.reference,
            DocumentName:"",
            userid:this.userID,
             CreatedBy:'Admin',
             UpdatedBy:'User',
             RowID:this.filtereddocList[0].RowID,
            };
            
            this.loginService.SaveLegalDocuments(json).subscribe((dataJson) => {
             
             if (dataJson['_body'].toString() === 'true') {
              
               Swal.fire("Updated Successfully");
                setTimeout(() => {
                  //this.message = "";
                }, 5000);
               
                
           }
          this.getLegaldocuments();
             });
             this.editdoc=false;
     }
     canceldocs(){
         this.editdoc=false;
     }
     addWork(){
          this.addnewwork=true;
          this.type="New"
          
     }
     saveNewwork(){
         
         if(this.workIndustry===""||this.workIndustry===undefined||this.workExperience===""||this.workExperience===undefined||
         this.workDescription===""||this.workDescription===undefined){
             return;
         }
         else{
        const jsonData = {
            Industry:this.workIndustry,
            Experience:this.workExperience,
            Description:this.workDescription,
            userid:this.userID,
        CreatedBy:'NewUser',
        UpdatedBy:'NewUser',
        RowID:this.rowID,
       
          };
        
         this.loginService.SaveWorkExperience(jsonData).subscribe((dataJson) => {
            
          if (dataJson['_body'].toString() === 'true') {
              if(this.type==="New"){
           Swal.fire("saved successfully");
              }
              else if(this.type==="Edit")
              {
                  Swal.fire("Updated successfully");
              }
           
          }
          this.workIndustry="";
          this.workExperience="";
          this.workDescription="";
          this.getWorkexperience();
        });
        this.addnewwork=false;
    }
     }
     editWork(row){
        
        this.type="Edit";
        this.addnewwork=true;
      this.rowID=row.RowID;
        this.workIndustry=row.Industry;
        this.workExperience=row.Experience;
        this.workDescription=row.Description;
        this.userID=this.userID;
     }
     cancelwork(){
         this.addnewwork=false;
         this.workIndustry="";
         this.workExperience="";
         this.workDescription="";
     }

     addcert(){
         this.addnewcert=true;
        this.type="New";
     }
     savecert(){
        
        if(this.certificateTitle===""||this.certificateTitle===undefined||this.certificateDesc===""||this.certificateDesc===undefined){
            return;
        }
        else{
        const jsonData = {
            Certificationpath:this.certificateCopy,
            Title:this.certificateTitle,
            Description:this.certificateDesc,
            userid:this.userID,
        CreatedBy:'NewUser',
        UpdatedBy:'NewUser',
        RowID:this.rowID,
       
          };
        
         this.loginService.SaveCertification(jsonData).subscribe((dataJson) => {
             
          if (dataJson['_body'].toString() === 'true') {
            if(this.type==="New"){
                Swal.fire("saved successfully");
                   }
                   else if(this.type==="Edit")
                   {
                       Swal.fire("Updated successfully");
                   }
           
          }
          this.certificateTitle="";
          this.certificateDesc="";
          this.certificateCopy="";
          this.getCertification();
        });
      
        
        this.addnewcert=false;
        }
     }
     editcert(row){
       this.typeoffile="certification";
       this.displaycertificates=true;
        
        this.type="Edit";
        this.addnewcert=true;
        this.certificatename=row.certificationName;
      this.rowID=row.RowID;
        this.certificateTitle=row.Title;
        this.certificateDesc=row.Description;
        this.userID=this.userID;
     }
    
     cancelcert(){
         this.addnewcert=false;
         this.certificateTitle="";
         this.certificateDesc="";
         this.certificateCopy="";
     }
     addEd(){
         this.addnewed=true;
         this.type="New";
     }
     saveEducation(){
        
        if(this.collegeName===""||this.collegeName===undefined||this.educationStartDate===""||this.educationStartDate===undefined
        || this.educationEndDate===""||this.educationEndDate===undefined){
            return;
        }
        else{
        const jsonData = {
            CollegeName:this.collegeName,
            Startdate:this.educationStartDate,
            Enddate:this.educationEndDate,
            userid:this.userID,
        CreatedBy:'NewUser',
        UpdatedBy:"NewUser",
        RowID:this.rowID,
       
          };
        
         this.loginService.SaveEducation(jsonData).subscribe((dataJson) => {
          
          if (dataJson['_body'].toString() === 'true') {
            if(this.type==="New"){
                Swal.fire("saved successfully");
                   }
                   else if(this.type==="Edit")
                   {
                       Swal.fire("Updated successfully");
                   }
           
          }
          this.collegeName="";
          this.educationEndDate="";
          this.educationStartDate="";
          this.getEducation();
        });
        
        this.addnewwork=false;
    }
     }
     GetUsers(){
       this.loginService.GetUsers(this.usertype).subscribe(data=>{  
         data = JSON.parse(data['_body']);
       this.tempUsersList =JSON.parse(JSON.stringify(data));

       let filterUser=this.tempUsersList.filter(x=>x.id.toString()==this.userID.toString());
       if(filterUser.length>0){
         this.UsersList=filterUser[0];
       
         if(this.UsersList.Profile!==null){
          // this.url="http://localhost:25396/"; 
          this.url=this.loginService.imageURL;
           this.IsProfilePic=true;
         }
         else{
           this.url="";
           this.UsersList.Profile='../../assets/images/user.png';
           this.IsProfilePic=false;
         }
       }
      
       })
     }
     edited(row){
       
        this.type="Edit";
        this.addnewed=true;
      this.rowID=row.RowID;
        this.collegeName=row.CollegeName;
        this.educationStartDate=row.StartDate.toString();
        this.educationEndDate=row.EndDate.toString();
        this.userID=this.userID;
     }
     canceled(){
         this.addnewed=false;
         this.collegeName="";
          this.educationEndDate="";
          this.educationStartDate="";
     }

     addPort(){
         this.addnewport=true;
         this.type="New";
     }
     fileChange1(input,param) {
    
      
      this.imagefile = this.loginService.filechange1(input, param,this.userID);
    
      this.imageservice.ImageUplode1.subscribe(Img =>{ 
        this.ProfilePic = Img
        this.GetUsers();
        if(this.usertype=="Initiator")
        {
          // this.iheader.ngOnInit();
          // this.iheader.GetUsers();
        }
        else{
          this.cheader.ngOnInit();
        }
      });
      
       
    }
   
     savePorfolios(){
         if(this.portfolioTitle===""||this.portfolioTitle===undefined||this.portfolioDesc===""||this.portfolioDesc===undefined){
             return;
         }
         else{
        const jsonData = {
            Title:this.portfolioTitle,
            Description:this.portfolioDesc,
            userid:this.userID,
        CreatedBy:'NewUser',
        UpdatedBy:'NewUser',
        RowID:this.rowID,
       
          };
         
         this.loginService.SavePortfolio(jsonData).subscribe((dataJson) => {
            
          if (dataJson['_body'].toString() === 'true') {
            if(this.type==="New"){
                Swal.fire("saved successfully");
                   }
                   else if(this.type==="Edit")
                   {
                       Swal.fire("Updated successfully");
                   }
           
          }
          this.portfolio="";
          this.portfolioTitle="";
          this.portfolioDesc="";
          this.getPortfolio();
        });
        this.addnewport=false;
        }
     }
     editport(row){
       this.displayportfolio=true;
       this.typeoffile="portfolio";
       
        this.type="Edit";
        this.addnewport=true;
        this.portfolioname=row.portfolioName;
      this.rowID=row.RowID;
        this.portfolio=row.Portfoliopath;
        this.portfolioTitle=row.Title;
        this.portfolioDesc=row.Description;
        this.userID=this.userID;
     }
     cancelport(){
         this.addnewport=false;
         this.portfolio="";
         this.portfolioTitle="";
         this.portfolioDesc="";
         this.type="New";
     }
}
